import { EnvironmentProviders, inject, provideAppInitializer, Provider } from '@angular/core';
import { AuthReloadControlService } from '@app/core/auth/services/auth-reload-control.service';
import { RELOAD_CONTROL_PROVIDER } from '@app/core/reload-control/reload-control.provider';
import { provideStates } from '@ngxs/store';

import { AuthService } from './services/auth.service';
import { AUTH_INITIALIZER_FACTORY } from './services/auth-initializer.factory';
import { AuthState } from './states/auth.state';
import { AuthProfileState } from './states/auth-profile.state';
import { AuthTokenState } from './states/auth-token.state';

export function provideAuth(): (Provider | EnvironmentProviders)[] {
  return [
    provideStates([AuthState, AuthTokenState, AuthProfileState]),
    provideAppInitializer(() => {
      const initializerFn = AUTH_INITIALIZER_FACTORY(inject(AuthService));
      return initializerFn();
    }),
    {
      provide: RELOAD_CONTROL_PROVIDER,
      useClass: AuthReloadControlService,
      multi: true,
    },
  ];
}
